export default "__VITE_PUBLIC_ASSET__eb4d283e__"